import React from "react";
import OUM1 from "../images/contenido/OUM1.jpg";
import OUM3 from "../images/contenido/OUM3.jpg";
import OUM4 from "../images/contenido/OUM4.jpg";
import Informes from "../images/contenido/informes.png";

import Navigation from "../components/Navigation";
import { Helmet } from "react-helmet";

const Oum = () => {
  return (
    <section className="nosotros talleres">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Observatorio Universitario de Medios - Memoria 2014-2024 - Fundación
          Gustavo Mohme Llona
        </title>
        <meta
          property="og:title"
          content="Observatorio Universitario de Medios - Memoria 2014-2024 - Fundación Gustavo Mohme Llona"
        />
      </Helmet>
      <div id="gustavo-mohme-llona" className="bg-white">
        <div className="container d-flex header-page">
          <div className="column-0">
            <div className="pre-title">2.2</div>
            <h1 className="color-blue">Observatorio Universitario de Medios</h1>
          </div>
          <div className="column-0">
            <div className="cont-mohme-0">
              <img
                src={OUM4}
                alt="Mesa de presentación del OUM"
                className="mohme-0"
              />
              <div className="legend">
                Mesa de presentación del OUM en la Universidad Antonio Ruiz de
                Montoya, con Stella Mohme, Franklin Cornejo y Milagros Olivera.
              </div>
              <div className="block-blue"></div>
            </div>
            <div className="block-blue-light"></div>
          </div>
        </div>
        <div className="container">
          <div className="container-text">
            <div className="quote quote-center quote-blue">
              <p>
                Una experiencia académica para profesionalizar el papel del
                periodista en la construcción de la opinión pública
              </p>
            </div>
            <p>
              El Observatorio Universitario de Medios (OUM) es una experiencia
              académica que facilita el análisis y reflexión sobre el papel del
              periodista como productor de contenidos y agente ético en la
              construcción de la opinión pública. El trabajo se realiza a través
              de la metodología del monitoreo de medios para comprender el valor
              y el peso informativo que tienen los medios en la agenda pública.
            </p>

            <p>
              El OUM surge como resultado de la alianza institucional entre la
              Universidad Antonio Ruiz de Montoya (UARM) y la Fundación Gustavo
              Mohme Llona, inició su trabajo en setiembre de 2016 aplicando
              módulos formativos en asignaturas de pregrado de la Escuela de
              Periodismo de la UARM, con esta dinámica continúa sus actividades
              en el presente año 2024. Se han elaborado ocho informes (que
              incluyen datos estadísticos y narrativos) y una sistematización
              reflexiva sobre el OUM que se presentan públicamente a través de
              talleres y conversatorios con el fin de destacar el importante
              papel de los medios y los periodistas en la configuración de una
              sociedad democrática con ciudadanos que puedan tener la mejor
              información posible para tomar sus propias decisiones.
            </p>
           

            <h4>2.2.1 ENFOQUE</h4>

            <p>
              El trabajo del observatorio ha permitido ampliar las capacidades
              para enseñar y producir periodismo de calidad, en contextos de
              polarización mediática y desinformación. Al ser el lenguaje
              creador de realidades y de opinión pública (Civila de Dios,
              Romero-Rodríguez y Aguaded, 2020), apreciamos que los medios de
              comunicación, e históricamente los periódicos, pero luego también
              la radio, la televisión y ahora las redes sociales, cumplen la
              tarea de ser informantes mediadores de realidades con una
              representación necesaria y clave para conocer sobre diferentes
              hechos que acontecen en el Perú y el mundo.
            </p>
            <figure className="img-left img-m">
              <div className="block-blue-light"></div>
              <img
                src={OUM1}
                alt="Paul Maquet y Virna Valdivia"
                className="img-m"
              />
              <div className="legend">
                Presentación del informe sobre la cobertura de la corrupción en
                los medios de comunicación (2018) por Paul Maquet y Virna
                Valdivia.
              </div>
            </figure>
            <p>
              Pese a la aparición en el tiempo de nuevos medios y la
              convergencia digital, los periódicos subsisten y se confirma su
              destacado rol en la construcción de narrativas y discursos; por
              ello consideramos que la presencia de la prensa y de los medios en
              la sociedad sigue siendo valiosa en la producción de información
              dirigida a la ciudadanía. Sin embargo, las representaciones
              mediáticas pueden convertirse en actorías políticas con sesgos
              infomativos o en malas prácticas de la profesión de informar, lo
              cual puede generar por ejemplo desconfianza de las audiencias
              frente a los medios, debido a coberturas mediáticas donde los
              grupos étnicos o las diferentes posiciones políticas no se sienten
              representados con justicia en los medios.
            </p>
            <p>
              Los medios contribuyen a la consolidación de la democracia, y para
              que esto suceda debe existir una democracia representativa y
              participativa en la que interactuen entre sí los medios, los
              periodistas, los políticos y los ciudadanos como actores claves de
              la opinión pública.
            </p>

            <p>
              Es así que, desde la perspectiva democrática, el papel activo de
              los medios y los periodistas contribuye a la configuración de los
              fenómenos comunicacionales de la opinión pública mediante la
              construcción de discursos y coberturas que permiten un
              acercamiento a la verdad y la justicia al momento de informar.
              Consideramos que ese trabajo para que sea lo más profesional y
              transparente posible requiere entrenamientos y formación como los
              que se desarrollan en el Observatorio Universitario de Medios.
            </p>

            <h4>2.2.2 METODOLOGÍA</h4>
            <p>
              A través de una metodología que se ha ido validando en el aula,
              entre grupo de pares integrado por docentes, expertos y
              estudiantes se ha puesto en relieve la relación del docente con el
              estudiante como parte de un trabajo colaborativo en equipo, que
              refuerza aspectos pedagógicos y deliberativos.
            </p>
            <p>
              Este marco de reflexión conjunta con la comunidad académica
              permite, en lo que podemos denominar (fase 1), determinar la
              temática del observatorio; el periodo de estudio y la muestra; la
              discusión sobre tratamientos y encuadres; distinguir entre
              información, opinión y anexos del periodismo como las caricaturas,
              las declaraciones políticas o mensajes de las redes sociales;
              entre otros aspectos de la construcción mediática de la realidad.
            </p>
            <figure className="img-center">
              <div className="block-blue-light"></div>
              <img src={OUM3} alt="Paul Maquet y Virna Valdivia" className="" />
              <div className="legend">
                Kathia Carrillo, Virna Valdivia, Stella Mohme, Amanda González,
                Paul Maquet, Franklin Cornejo y Ernesto Cavassa.
              </div>
            </figure>

            <p>
              Luego, en una siguiente (fase 2) se establecen los grupos de
              trabajo. Se selecciona la data que se analizará, lo cual incluye
              el objeto de estudio y los criterios relevantes del monitoreo. Se
              elabora la ficha de observación y se aplica la misma.
            </p>
            <p>
              Con la información recogida mediante la ficha (fase 3) se elaboran
              unas primeras reflexiones sobre el resultado preliminar de lo
              visto por cada uno de los grupos, se atienden dudas, se corrigen
              eventuales errores en la aplicación de la ficha y se construye la
              data para cada uno de los medios observados.
            </p>
            <div className="quote quote-blue">
                Desde el 2016 se han publicado 7 documentos de seguimiento y análisis de los medios en nuestro país.
              </div>
            <p>
              Con la información consolidada de todos los medios observados (o
              del medio observado), (fase 4) se pasa a una revisión y cotejo
              general de la misma, que incluye la revisión de los contenidos y
              el análisis siguiendo los criterios de conformación del discurso
              periodístico; tales como extensión de la noticia, origen de la
              noticia, formato de la información publicada, actor referido,
              actor referente entre otros.
            </p>
           
            <p>
              Finalmente, (fase 5) se elabora el informe, se incluyen las
              miradas de los grupos de trabajo. Y se presentan los resultados
              obtenidos en plenarias con los estudiantes y docentes. Previas
              coordinaciones con las contrapartes se publican los resultados
              para la descarga libre y gratuita; también se socializan los
              mismos en actividades públicas y en talleres con público externo.
            </p>
            <h4>2.2.3. APRENDIZAJES Y RETOS</h4>
            <p>
              Como parte de los aprendizajes en la experiencia del OUM podemos
              indicar algunos aspectos significativos relacionados con la
              cobertura, el tratamiento mediático y la experiencia de los
              estudiantes y docentes.
            </p>
            <h5>A. En los medios</h5>
            <p>
              Se ha identificado a través de los monitoreos realizados en la
              prensa, televisión y medios digitales, que el papel de los actores
              referidos y actores referentes en la cobertura de los medios marca
              la agenda noticiosa, las menciones a dichos autores puede ser
              variada y frecuente; lo cual puede conducir a una cierta
              incidencia en la agenda pública.
            </p>
            <ul>
              <li>
                En contextos de crisis política y procesos electorales se tiende
                a una editorialización, con una intensidad en las opiniones que
                pueden estar matizadas con adjetivos calificativos o
                descalificativos en relación a los actores.
              </li>
              <li>
                El uso de la nota informativa es constante en el tratamiento
                informativo, es un 70%-80% de la cobertura, que se complementa
                con columnas de opinión, entrevistas y artículos. Aparece
                también apuntes como declaraciones de actores políticos y
                ciudadanos, caricaturas y fotografías que complementan el menú
                informativo.
              </li>
              <li>
                Los que más declaran en las informaciones tienden a ser fuentes
                oficiales, gran parte de ellos son hombres, y la participación
                de las mujeres es escasa.
              </li>
              <li>
                Se ha encontrado que se tiende a proponer a los sucesos como un
                “accidente” o “cambio climático” como sujetos de la noticia; se
                ha identificado que esto se da por la poca especialización en el
                periodismo, escasez de fuentes especializadas y la falta de
                rutinas periodísticas. Este tipo de información podría generar
                vacíos de información, alarmismo, y posibles fake news.
              </li>
            </ul>

            <h5>B. En los estudiantes</h5>
            <p>Por el lado de los aprendizajes con la comunidad estudiantil encontramos lo siguiente.</p>
            <ul>
              <li>Los estudiantes desarrollan capacidades analíticas que les permiten distinguir entre información, opinión, y datos anexos al periodismo; como también comprenden la importancia de las rutinas periodísticas para producir textos de tipo noticioso.</li>
              <li>Los estudiantes reconocen la importancia de acercarse a las fuentes, asumir con empatía el papel de ser informantes y actuar con solidez ética en la formación de opinión pública.</li>
              <li>Los estudiantes aprenden a trabajar en equipo de manera colaborativa, establecen espacios de deliberación y escucha respetuosa, ya sea para el disenso como para el acuerdo.</li>
              <li>Los estudiantes desarrollan reflexiones teóricas sobre la agenda setting, el framing, el priming y la opinión pública como también establecen conexiones metodológicas como el análisis crítico del discurso y el análisis de contenido.</li>
            </ul>
            <div className="bg-blue-main testimonio">
                <p className="testimonio-texto"><span>"</span>Considero que la construcción de un observatorio es indispensable para una buena comunicación entre la ciudadanía y medios de comunicación. Mediante ella elaboramos una opinión pública sólida y transparente. Además de ello es enriquecedora, porque mediante el análisis y los datos podemos descubrir una serie de faltas que a simple vista no se ven. Aprendí a tener paciencia y mayor concentración en el momento de analizar algún dato, por ejemplo; a desarrollar mi pensamiento crítico y aplicar ese pensamiento crítico a otros estudios. Un observatorio puede destapar incluso injusticias, puede hacer que la democracia llegue a puntos donde el derecho a expresarse es limitado.<span>"</span></p>
                <p className="text-right"><i><strong>Esteffanía Arias</strong></i><br /><i><small>Estudiante de la UARM</small></i></p>
            </div>
            <h5>C. En los docentes</h5>
            <ul>
              <li>Se asume el trabajo del monitoreo de medios con profesionalismo, tomando distancia de posiciones fiscalizadores o moralistas frente a los medios; pero adoptando un análisis que permita generar datos para reflexión y la investigación sobre el papel de los medios en diferentes sucesos de la realidad social.</li>
              <li>La reflexión sustentada en la investigación (por ejemplo sobre la agenda setting o el papel del periodismo de calidad en la democracia), la experiencia de los docentes coordinadores y las reuniones de análisis y discusión acompañan el proceso de elaboración de cada uno de los informes.</li>
            </ul>

            <h5>D. Retos</h5>
            <p>Entre los retos del OUM a futuro se encuentra la posibilidad de diversificar los medios observados con el fin de ampliar el estudio y comprensión de las agendas noticiosas; de igual manera se considera importante afianzar aspectos logísticos y técnicos que permitan consolidar el alcance del trabajo del OUM.</p>

            

            <figure className="img-center">
              <img src={Informes} alt="Portadas de los 7 informes publicados hasta el momento por el Observatorio Universitario de medios." className="" />
              <div className="legend">
              Portadas de los 7 informes publicados hasta el momento por el Observatorio Universitario de medios.
              </div>
            </figure>

            <div className="quote quote-center text-center quote-blue">
              <p>
              Las publicaciones del OUM pueden ser consultadas en los siguientes enlaces:<br /><br />
              Informes OUM:<br/><a href="https://fundacionmohme.org/oum/">https://fundacionmohme.org/oum/</a><br /><br />Periodismo libre transformador en tiempo de crisis:<br/><a href="https://library.fes.de/pdf-files/bueros/peru/19885.pdf">https://library.fes.de/pdf-files/bueros/peru/19885.pdf</a></p>

            </div>

          </div>
          <Navigation
            prev="https://fundacionmohme.org/especiales/memoria-2024/talleres-periodismo"
            textPrev="2.1 Talleres sobre periodismo (actividades de formación)"
            next="https://fundacionmohme.org/especiales/memoria-2024/cultura-digital"
            textNext="2.3 Sociedad de la información y cultura digital para la ciudadanía"
          />
        </div>
      </div>
    </section>
  );
};

export default Oum;
